// ABOUTME: SPEC-82 §4.7 / OQ-3 — the desktop twin of a mobile `bottom + lift`: the revealed row's lift in authored
// ABOUTME: px, turned into a percentage of the viewport height for the tag ceiling (pure; mirrors RAIL_UNIT).

import { UI_SCALE, RAIL_UNIT_FLOOR_PX } from '../components/ReelChrome/railGeometry';

const FRAME_W = 3840; // the desktop authoring frame (railGeometry.js: 1/3840 = one authored px as a fraction of width)

/** One authored desktop px in real px at this width — the JS mirror of RAIL_UNIT's clamp(). */
export function railUnitPx(viewportWidth) {
  return Math.min(Math.max((viewportWidth * UI_SCALE) / FRAME_W, RAIL_UNIT_FLOOR_PX), UI_SCALE);
}

/** `liftAuthored` desktop px as a percentage of the viewport height; 0 for a zero lift or an unmeasured viewport. */
export function desktopLiftPct(liftAuthored, viewportWidth, viewportHeight) {
  if (!liftAuthored || !viewportWidth || !viewportHeight) return 0;
  return ((liftAuthored * railUnitPx(viewportWidth)) / viewportHeight) * 100;
}
